/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import birdata from "../api.js";
import ko from "knockout";
import _ from "underscore";

var program = {
	code: "wa_cockies",
	name: "Southwest Black-Cockatoo Recovery Program",
	description: "The Southwest Black-Cockatoo Recovery Program works with local communities, landholders and land managers to secure the protection and conservation of three threatened black-cockatoos throughout southwestern Australia, and conducts the annual Great Cocky Count.",
	load: function() {
		return birdata.lookup().then(function(lookups) {
			program.options = {
				approach_direction: lookups.approach_direction,
				habitats: lookups.wa_cockies_habitat,
				plants: lookups.wa_cockies_plant,
				activities: lookups.wa_cockies_activity
			};
			return true;
		});
	},
	//options: see load(),
	fields: function() {
		return {
			approachDirection: ko.observable(null),
			partOfGreatCockyCount: ko.observable(false),
			habitats: ko.observableArray([]),
			plants: ko.observableArray([]),
			activities: ko.observableArray([])
		};
	},
	programData: function(survey) {
		var fields = program.fields();
		return {
			fields: fields,
			validations: [],
			options: program.options
		};
	},
	visibleSharedSiteLayers: () => ["gcc_roost"],
	updateSurveyJSON: function(json, survey) {
		var fields = survey.programData().wa_cockies.fields;

		function code(f) {
			return f == null ? null : f.code;
		}

		function codes(f) {
			return _.pluck(f, 'code');
		}

		json.wa_cockies = {
			approach_direction: code(fields.approachDirection()),
			part_of_great_cocky_count: fields.partOfGreatCockyCount(),
			habitats: codes(fields.habitats()),
			plants: codes(fields.plants()),
			activities: codes(fields.activities())
		};
	},
	loadFromJSON: function(json, fields, survey) {
		var options = this.options;
		var data = json.wa_cockies;

		if(!data) return; //incomplete survey

		function lookup(items, code) {
			return _.findWhere(items, {code: code});
		}

		function lookupMany(items, codes) {
			return _.map(codes, function(code) {
				return lookup(items, code);
			});
		}

		fields.approachDirection(lookup(options.approach_direction, data.approach_direction));
		fields.partOfGreatCockyCount(!!data.part_of_great_cocky_count);

		fields.habitats(lookupMany(options.habitats, data.habitats));
		fields.plants(lookupMany(options.plants, data.plants));
		fields.activities(lookupMany(options.activities, data.activities));
	}
};

export default program;
